import {Component, EventEmitter, Input, OnInit, Output} from "@angular/core";
import {Website} from "../../../website";
import {Product, ProductOrigin, ProductType} from "../../../product";
import {Permissions} from "../../../../../user/permissions";
import {UserSubscription, UserSubscriptionCategory, UserSubscriptionType} from "../../../../../user/user-subscription";
import {DialogService} from "../../../../../../ng2-bootstrap-modal/dialog.service";
import {PremiumPluginDialogComponent} from "../../../premium-plugin-dialog/premium-plugin-dialog.component";
import {Router} from '@angular/router';
import * as fromStore from "../../../../../store";
import {Store} from "@ngrx/store";
import {ActivityAction, ActivityStatus, IActivity} from "../../../../../activities/activity";
import {DbStoreState} from "../../../../../store/reducers";
import {Observable} from "rxjs";
import {ProductActionService} from "../../../product-action.service";
import {Config} from "../../../../../config/config";
import {
  MultisiteActionConfirmDialogComponent
} from "../../../../../shared/components/dialogs/mulitiste-action-confirm-dialog/multisite-action-confirm-dialog.component";
import {TextUtils} from "../../../../../shared/utils/text-utils";
import {DbModalService} from "../../../../../modules/modal/modal";
import {GoogleAnalyticsService} from "../../../../../shared/services/google-analytics/google-analytics.service";
import {map} from "rxjs/operators";
import {OneMonthFreeComponent} from "../../../../../shared/components/dialogs/one-month-free/one-month-free.component";

@Component({
    selector: 'db-available-plugin',
    templateUrl: './available-plugin.component.html',
    styleUrls: ['./available-plugin.component.scss'],
    standalone: false
})
export class AvailablePluginComponent implements OnInit {

  public ActivityAction = ActivityAction;
  public ActivityStatus = ActivityStatus;

  public ProductType: any = ProductType;
  public UserSubscriptionType: any = UserSubscriptionType;
  private isPublishedSinglePlugin: boolean;

  @Input() website: Website;
  @Input() parent?: Product;
  @Input() product: Product;
  @Input() hasExtensions: Product;
  @Input() userPermissions: Permissions;
  @Input() userSubscriptions: UserSubscription[];
  @Input() currentSubscription: UserSubscription;
  @Input() activeTab: string;
  @Input() featuredPlugin: boolean;
  @Input() companyName: string = 'Dashboard';
  @Output() toggled: EventEmitter<void>;

  public isManagable: boolean;
  public plugins_links: Object;

  public isWpProductInstalled$: Observable<boolean>;

  public ongoingActivity$: Observable<IActivity>;
  public ongoingActivityStatusClass$: Observable<string>;

  constructor(
    private _store: Store<DbStoreState>,
    private _router: Router,
    private _dialogService: DialogService,
    public _productActionService: ProductActionService,
    public _modalService: DbModalService,
    public _googleAnalyticsService: GoogleAnalyticsService,
  ) {
    this.toggled = new EventEmitter<void>();
  }

  ngOnInit() {
    this.isManagable = !this.website.isLocalhost && this.userPermissions.canManageContent;
    this.isPublishedSinglePlugin = Config.publishedSinglePluginPlans.includes(this.product.slug);

    this.plugins_links = {
      "form-maker": "form-maker",
      "photo-gallery": 'photo-gallery',
      "event-calendar-wd": 'event-calendar',
      "slider-wd": 'slider',
      "wd-google-maps": 'google-maps',
      "wd-google-analytics": 'google-analytics',
      "ecommerce-wd": 'ecommerce',
      "wd-mailchimp": 'mailchimp',
      "wd-facebook-feed": 'facebook-feed',
      "wd-instagram-feed": 'instagram-feed',
      "wd-youtube": 'youtube',
      "post-slider-wd": 'post-slider',
      "ad-manager-wd": 'ad-manager',
      "contact-form-maker": 'contact-form-maker',
      "contact-form-builder": 'contact-form-builder',
      "staff-team": 'team',
      "faq-wd": 'faq',
      "spider-event-calendar": 'spider-calendar',
      "spider-facebook": 'spider-facebook',
      "catalog": 'spider-catalog',
      "player": 'spider-video-player',
      "widget-twitter": 'widget-twitter',
      "spider-contacts": 'spider-contacts',
      "spider-faq": 'spider-faq',
      "zoom-widget": 'zoom',
      "tenweb-speed-optimizer": 'speed-optimization'
    };

    this.isWpProductInstalled$ = this._store.select(fromStore.getWebsitePlugin(this.website.id, this.product.slug))
      .pipe(map((product: Product) => {
        return !!product && (product.origin === ProductOrigin.WORDPRESS || (product.origin === ProductOrigin.TEN_WEB && product.installed));
      }));

    this.ongoingActivity$ = this._store.select(fromStore.getProductOngoingActivity(this.website.id, this.product.slug));
    this.ongoingActivityStatusClass$ = this.ongoingActivity$.pipe(map((activity: IActivity): string => {
      if (!activity) {
        return '';
      }

      if (activity.status === ActivityStatus.DONE) {
        return 'success';
      }
      if (activity.status === ActivityStatus.FAILED) {
        return 'danger';
      }

      return 'info';
    }));
  }

  public installAndActivate(): void {
/*    if ( this.activeTab === 'wordpress' && this.currentSubscription && this.currentSubscription.type === UserSubscriptionType.FREE) {
      const analyticsData = {
        eventCategory: 'Free Upgrade Offer',
        eventAction: "Locked button click",
        eventLabel: "Upload plugin"
      };
      const modal = this._modalService.open(OneMonthFreeComponent, {height: 600, width: 940});
      modal.componentInstance.mode = 'feature';
      this._googleAnalyticsService.sendAnalyticsEventWithCore(analyticsData);
    } else {*/
      const network = 0;
      if (this.website.isNetwork || (!this.website.isNetwork && this.website.parentId)) {
        this.openConfirmationDialog(network, ActivityAction.INSTALL_ACTIVATE, true);
      } else {
        this.dispatchActions(network, true);
      }

  }

  public installPaidVersion(): void {
    const network = 0;
    if (this.website.isNetwork || (!this.website.isNetwork && this.website.parentId)) {
      this.openConfirmationDialog(network, ActivityAction.INSTALL_ACTIVATE);
    } else {
      this.dispatchActions(network);
    }
  }

  public onItemToggled(): void {
    this.toggled.emit();
  }

  public showPremiumPluginDialog(product: Product): void {
    if (this.currentSubscription.type === UserSubscriptionType.FREE && this.isPublishedSinglePlugin) {
      this._dialogService
        .addDialog(PremiumPluginDialogComponent, {
          website: this.website,
          product: product,
          isManagable: this.isManagable,
          userSubscriptions: this.userSubscriptions,
          currentSubscription: this.currentSubscription
        } as any);
    } else {
      const activeTab = (this.currentSubscription.category === UserSubscriptionCategory.STARTER || this.currentSubscription.category === UserSubscriptionCategory.REGISTERED) ? 'platform' : 'bundle';
      this._router.navigate(['/upgrade-plan'], {
        queryParams: {
          plugin_slug: product.slug,
          plugin_title: product.title,
          active_tab: activeTab
        }
      });
    }
  }

  private dispatchActions(network, parent = false) {
    if (this.parent && !this.parent.paidVersionInstalled && parent) {
      this._store.dispatch(new fromStore.InitWebsiteProductAction({
        website: this.website,
        products: [this.parent],
        action: ActivityAction.INSTALL_ACTIVATE,
        network: network
      }));
    }

    this._store.dispatch(new fromStore.InitWebsiteProductAction({
      website: this.website,
      products: [this.product],
      action: ActivityAction.INSTALL_ACTIVATE,
      network: network
    }));
  }

  private openConfirmationDialog(network, action, parent = false) {
    this._dialogService
      .addDialog(MultisiteActionConfirmDialogComponent, {
        header: TextUtils.getText(action === ActivityAction.DEACTIVATE ? 'text_multisiteDeactivate.header' : 'text_multisiteActivate.header'),
        message: TextUtils.getText(action === ActivityAction.DEACTIVATE ? 'text_multisiteDeactivate.message' : 'text_multisiteActivate.message'),
        singleSiteButtonText: TextUtils.getText(action === ActivityAction.DEACTIVATE ? 'text_deactivate' : 'text_activate'),
        multisiteButtonText: TextUtils.getText(action === ActivityAction.DEACTIVATE ? 'text_networkDeactivate' : 'text_networkActivate'),
      })
      .subscribe((confirmed: string | boolean) => {
        if (confirmed) {
          if (confirmed === 'network') {
            network = 1;
          }
          this.dispatchActions(network, parent);
        }
      });
  }

  public get displayAuthor(): string {
    if (!this.product || !this.product.author) {
      return '';
    }
    return this.product.author.replace(/10Web/gi, this.companyName);
  }

  public get displayTitle(): string {
    if (!this.product || !this.product.title) {
      return '';
    }
    return this.product.title.replace(/10Web/gi, this.companyName);
  }

  public get displayDescription(): string {
    if (!this.product || !this.product.description) {
      return '';
    }
    return this.product.description.replace(/10Web/gi, this.companyName);
  }

}
